export function isFluidProp(prop) {
    return Array.isArray(prop) && Array.isArray(prop[0]);
}
